type FeatureString = "UPLOAD" | "PDF_VIEWER" | "ANHANGE_IN_PDF" | "CHANGE_LANGUAGE" | "DEVELOP" | "DEMO" | "STEUERBERECHNUNG"
type FeatureResponse = FeatureString[]

/**
 * Service wird in index.tsx aufgerufen
 */
export class FeatureService {
    private static activeFeatures: string[] = []

    public static isFeatureActive = (feature: FeatureString) => {
        return FeatureService.activeFeatures.includes(feature)
    }

    public static getFeatures = (): Promise<FeatureResponse> => {
        return fetch("/api/v1/activatedFeatures")
            .then((res) => res.json())
            .then((res: FeatureResponse) => (FeatureService.activeFeatures = res))
    }
}
